import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const YoungPersonForm = () => {
  const [formData, setFormData] = useState({
    youngPersonName: '',
    homeName: '',
    email: '',
    message: '',
    honeypot: ''
  });
  const [status, setStatus] = useState({ type: null, message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Honeypot spam protection
    if (formData.honeypot) {
      return;
    }

    // Validate fields
    if (!formData.youngPersonName.trim() || !formData.homeName.trim() || !formData.email.trim() || !formData.message.trim()) {
      setStatus({
        type: 'error',
        message: 'Please fill in all required fields.'
      });
      return;
    }

    setIsSubmitting(true);
    setStatus({ type: null, message: '' });

    try {
      // Send email using EmailJS
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID',
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'YOUR_TEMPLATE_ID',
        {
          from_name: formData.youngPersonName.trim(),
          home_name: formData.homeName.trim(),
          from_email: formData.email.trim(),
          message: formData.message.trim(),
          to_email: 'Info@testacare.co.uk, arshadashraf@testacare.co.uk',
          form_type: 'Young Person Update'
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY'
      );

      setStatus({
        type: 'success',
        message: 'Thank you for getting in touch. We will respond soon.'
      });

      setFormData({
        youngPersonName: '',
        homeName: '',
        email: '',
        message: '',
        honeypot: ''
      });

      setTimeout(() => {
        setStatus({ type: null, message: '' });
      }, 5000);

    } catch (error) {
      console.error('Young Person form error:', error);
      setStatus({
        type: 'error',
        message: 'Something went wrong. Please try again later or email us directly at Info@testacare.co.uk'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="bg-white py-16 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-sm uppercase tracking-[0.3em] text-orange-500">Young Person</p>
          <h2 className="text-4xl md:text-5xl font-light text-[#2c5f7c]">Send us a quick update</h2>
          <p className="mt-4 text-lg text-[#2c5f7c]">
            Let us know how you're doing or what you need from the Testa Care team. Your message goes directly to our
            support office.
          </p>
        </div>

        <form className="space-y-6" onSubmit={handleSubmit}>
          {/* Honeypot field for spam protection */}
          <input
            name="honeypot"
            style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}
            type="text"
            tabIndex="-1"
            autoComplete="off"
            value={formData.honeypot}
            onChange={handleChange}
          />
          <div>
            <label className="block text-sm font-semibold text-[#2c5f7c] mb-2" htmlFor="youngPersonName">
              Young person&apos;s name<span className="text-orange-500">*</span>
            </label>
            <input
              id="youngPersonName"
              name="youngPersonName"
              type="text"
              required
              value={formData.youngPersonName}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#EA8B3C]"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-[#2c5f7c] mb-2" htmlFor="homeName">
              Name of your home<span className="text-orange-500">*</span>
            </label>
            <input
              id="homeName"
              name="homeName"
              type="text"
              required
              value={formData.homeName}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#EA8B3C]"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-[#2c5f7c] mb-2" htmlFor="email">
              Your email address<span className="text-orange-500">*</span>
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#EA8B3C]"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-[#2c5f7c] mb-2" htmlFor="message">
              Your message<span className="text-orange-500">*</span>
            </label>
            <textarea
              id="message"
              name="message"
              rows="6"
              required
              value={formData.message}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#EA8B3C]"
            ></textarea>
          </div>

          {status.type && (
            <div
              className={`text-sm px-4 py-3 rounded ${
                status.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'
              }`}
            >
              {status.message}
            </div>
          )}

          <div className="flex justify-end">
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-[#2f4c74] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#263b5a] transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? 'Sending...' : 'Send message'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default YoungPersonForm;
